const categories = require('./categories.json')
const projects = require('./projects.json')

module.exports = {
  categories,
  projects
}



// WEBPACK FOOTER //
// ./data/2019/index.js